import { storeToRefs } from "pinia";
import { computed } from "vue";

import { useUserStore } from "@/stores";

export const useFreeSearchLabel = () => {
  const { userData } = storeToRefs(useUserStore());

  const showFreeSearchCountdown = computed<boolean>(
    () => userData.value.freeSearchesLeft !== null && userData.value.freeSearchesLeft >= 0
  );

  const freeSearchLabelColor = computed<"default" | "attention" | "warning">(() => {
    if (userData.value.freeSearchesLeft === null) {
      return "default";
    }

    if (userData.value.freeSearchesLeft === 0) {
      return "warning";
    }

    return "default";
  });

  return {
    showFreeSearchCountdown,
    freeSearchLabelColor
  };
};
